module.exports = __webpack_public_path__ + "img/Bean-1.95cbf659.svg";